module.exports = __webpack_public_path__ + "img/x-solid.29f1c1e1.svg";